import { ShoppingCart } from 'src/app/models/shopping-cart';
import { HttpErrorResponse } from '@angular/common/http';
import { Product } from 'src/app/models/product';
import { ProductService } from 'src/app/services/product/product.service';
import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from 'src/app/services/shopping-cart/shopping-cart.service';

@Component({
  selector: 'app-firenet-main',
  templateUrl: './firenet-main.component.html',
  styleUrls: ['./firenet-main.component.css']
})
export class FirenetMainComponent implements OnInit {

  public products: Product[] = [];
  public errorMsg: string;
  public shoppingCart: ShoppingCart;

  constructor(private productService: ProductService,
    private shoppingCartService: ShoppingCartService) {

    this.shoppingCartService.getMessageCartIsReady()
      .subscribe((data) => {
        this.shoppingCart = this.shoppingCartService.getCart();
      })
  }

  ngOnInit() {
    this.shoppingCart = this.shoppingCartService.getCart();
    this.products = this.productService.getLocalProductsByProtocolCategroy("Firenet");
  }
}
